import { mixin } from 'class-mixins';
import { ErrorNotifyTrait } from '@goodt-common/shared';

/**
 * @extends {ErrorNotifyTrait}
 */
export class BaseViewModel {
    /**
     * @param {Error} error
     */
    handleError(error) {
        if (error.isCancel) {
            return;
        }
        this.notifyError(error);
    }
}

mixin(BaseViewModel, ErrorNotifyTrait);
